// =============================================================================
// The confirmation toast.
//
// The markup lives in the footer block (`.toast[data-toast]`) so it exists on
// every page, and CSS does the sliding in and out from the `.is-visible` class
// — this module only writes the two lines of text and decides how long the
// message stays up.
// =============================================================================

/** How long a message stays up, in ms. Matches the design's own timing. */
const DURATION = 2600;

let timer = 0;

/**
 * Show a toast.
 *
 * @param {string} title The headline, e.g. "Added to cart".
 * @param {string} [sub] The supporting line, e.g. the product and quantity.
 */
export function showToast(title, sub = "") {
	const toast = document.querySelector("[data-toast]");
	if (!toast) {
		return;
	}

	const titleEl = toast.querySelector("[data-toast-title]");
	const subEl = toast.querySelector("[data-toast-sub]");

	// textContent, never innerHTML: both lines carry product titles, which are
	// editor-authored and therefore untrusted here.
	if (titleEl) {
		titleEl.textContent = title;
	}
	if (subEl) {
		subEl.textContent = sub;
	}

	toast.classList.add("is-visible");

	// A second message inside the first one's lifetime replaces it and restarts
	// the clock. Letting the earlier timer run would cut the new message short,
	// which reads as the site swallowing a confirmation.
	clearTimeout(timer);
	timer = setTimeout(() => toast.classList.remove("is-visible"), DURATION);
}
